import OutboundJourneySearchDate from './OutboundJourneySearchDate';

export default OutboundJourneySearchDate;
